import { render } from "./AvatarIcon.vue?vue&type=template&id=43129927&ts=true"
import script from "./AvatarIcon.vue?vue&type=script&lang=ts"
export * from "./AvatarIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__